// Texty prezentační vrstvy vyhledávání (searchRender.js).
export default {
  // H1 „Hledali jste „pila““, na mobilu je předpona jen pro čtečky (mock 2026-10-14)
  h1Pre: 'Hledali jste ',
  quoteOpen: '„',
  quoteClose: '“',
  // Řada čipů kategorií výsledku pod H1 (mock „Doporučeno" 2026-10-14)
  chipsLabel: 'Kategorie',
  chipsMore: (n) => 'Další (' + n + ')',
  chipsLess: 'Méně',
  // Řádek sekce Kategorie: „45 nalezených" (počet shod s dotazem, ne velikost kategorie)
  catFound: ['nalezený', 'nalezené', 'nalezených'],
  showAll: (n) => 'Zobrazit vše (' + n + ')',
  shown: 'Zobrazeno ',
  nonePre: 'Pro ',
  nonePost: ' jsme nic nenašli',
  noneText:
    'Zkontrolujte překlepy nebo zkuste obecnější výraz: místo modelového označení hledejte typ nářadí. Rádi vám také poradíme po telefonu.',
  // při vypnutých telefonech (#bs-config[data-bs-phones=off]) nesmí text slibovat hovor
  noneTextNoPhone:
    'Zkontrolujte překlepy nebo zkuste obecnější výraz: místo modelového označení hledejte typ nářadí. Rádi vám také poradíme e-mailem.',
  nonePlaceholder: 'Zkuste hledat jinak…',
  submit: 'Hledat',
  queries: 'Nejhledanější dotazy',
  browse: 'Procházet kategorie',
  didYouMean: 'Mysleli jste: ',
  tips: [
    'Zkuste kratší nebo obecnější výraz: místo „OD9081w 100 mm“ hledejte „přímočará pila“.',
    'Zkontrolujte diakritiku a překlepy, vyhledávání je na ně citlivé.',
    'Hledejte podle značky: ONDRAGON, BULLTECH, POWERMAT, GEKO, BASS.',
    'Nebo produkt najděte v katalogu podle kategorie níže.',
  ],
  // index tipu v poli `tips`, který se vypustí, když index nabídne opravený dotaz
  // (typo-tolerantní vyhledávání dělá radu o překlepech zbytečnou)
  typoTipIndex: 1,
  advice: {
    eyebrow: 'Poradna Jipos',
    title: 'Nevíte, jak se to jmenuje?',
    text: 'Popište nám, co potřebujete. Najdeme model a poradíme s výkonem i příslušenstvím.',
    textNoPhone: 'Napište nám, co potřebujete. Najdeme model a poradíme s výkonem i příslušenstvím.',
    mailLabel: 'Napsat dotaz',
  },
  plurals: {
    cats: ['kategorie', 'kategorie', 'kategorií'],
    brands: ['značka', 'značky', 'značek'],
    posts: ['článek', 'články', 'článků'],
    pages: ['stránka', 'stránky', 'stránek'],
    products: ['produkt', 'produkty', 'produktů'],
  },
};
